// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"Bz-z","smallCardRow":"Cz-z","largeCardRow":"Dz-z","productSearchRow":"Ez-z","curatedRow":"Fz-z"};